import React from 'react';

import { MoonshotBox } from './MoonshotBox';
import { MoonshotSteps } from 'app/common/data/campaigns';
import { MoonshotSubmitFunction } from './types';
import styles from './MoonshotPlanSelection.less';
import Icon, { IconName, IconColor } from 'app/common/components/controls/icon';
import { Noun, Verb, trackUe } from '@trello/analytics';

const featureList = [
  {
    icon: IconName.Board,
    title: 'Unlimited Team Boards, Endless Possibilities',
    content:
      'Free teams have up to 10 boards. Get unlimited with Business Class!',
  },
  {
    icon: IconName.PowerUp,
    title: 'Unlimited Connections and Integrations',
    content:
      'Take your boards further with Calendar, Google Drive, Dropbox and more!',
  },
  {
    icon: IconName.ButlerBot,
    title: 'Powerful Automation, No Coding Required',
    content:
      'Reduce time spent on repetitive tasks with Butler, our native Automation tool',
  },
  {
    icon: IconName.Heart,
    title: 'Priority Support',
    content: 'Get help when you need it, 24/7.',
  },
  {
    icon: IconName.Vote,
    title: 'Enhanced Admin Permissions',
    content:
      'Unlock finer control over visibility, engagement, inviting, and more',
  },
  {
    icon: IconName.Template,
    title: 'Keep Work Consistent for Everyone',
    content: 'Make your team boards easily reusable with Templates',
  },
];

interface MoonshotPlanSelectionProps {
  onSubmit: MoonshotSubmitFunction;
}

export const MoonshotPlanSelection: React.FC<MoonshotPlanSelectionProps> = ({
  onSubmit,
}) => {
  const onContinueWithTracking = () => {
    onSubmit(MoonshotSteps.PAYMENT_FORM);
    trackUe({
      category: Noun.MOONSHOT,
      verb: Verb.SUBMITS,
      directObj: Noun.BUSINESS_CLASS_UPSELL,
    });
  };

  const onSkipWithTracking = () => {
    onSubmit(MoonshotSteps.SUCCESS);
    trackUe({
      category: Noun.MOONSHOT,
      verb: Verb.SKIPS,
      directObj: Noun.BUSINESS_CLASS_UPSELL,
    });
  };

  return (
    <>
      <MoonshotBox className={styles.upperBox}>
        <div className={styles.bcBanner}>
          <h1 className={styles.bcBannerTitle}>
            <Icon name={IconName.BusinessClass} color={IconColor.Light} />{' '}
            Business Class
          </h1>
          <h2 className={styles.bcBannerDesc1}>
            Start with Business Class to unlock more efficiency within your
            team!
          </h2>
          <h3 className={styles.bcBannerDesc2}>
            Upgrade for as low as $9.99 per user per month
          </h3>
        </div>

        <ul className={styles.featureList}>
          {featureList.map(({ icon, title, content }) => (
            <li key={title} className={styles.featureItem}>
              <Icon name={icon} medium className={styles.featureIcon} />
              <span className={styles.featureTitle}>
                {title}
                <span className={styles.featureContent}>{content}</span>
              </span>
            </li>
          ))}
        </ul>

        <button className={styles.ctaButton} onClick={onContinueWithTracking}>
          Get Started with Business Class
        </button>
      </MoonshotBox>
      <MoonshotBox className={styles.lowerBox}>
        <h2 className={styles.lowerBoxTitle}>Not ready yet? No problem!</h2>
        <p className={styles.lowerBoxDesc}>
          Free Teams can create up to 10 boards, and can have 1 Power-Up per
          board. For admin permissions, priority support, and more, upgrade your
          team to Business Class.
        </p>
        <button className={styles.ctaLink} onClick={onSkipWithTracking}>
          Get Started For Free
        </button>
      </MoonshotBox>
    </>
  );
};
